import styled from "styled-components";

export const ValidationContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
